/*
 * Copyright (C) 2017 BossieTech Co.,Ltd. All Rights Reserved.
 * Creator  :   Alfred
 * Date     :   2018/07/09
 */
import request from '@/utils/request'

// 获取部门树
export function getDepartments() {
  return request({
    url: '/departments',
    method: 'get'
  })
}

// 获取用户
export function getUsers(params) {
  return request({
    url: '/users',
    method: 'get',
    params
  })
}
// 获取目标用户的信息
export function getUserInfo(id) {
  return request({
    url: `/users/${id}`,
    method: 'get'
  })
}
// 修改签名
export function updateUserSignature(id, data) {
  return request({
    url: `/users/${id}/signature`,
    method: 'post',
    data
  })
}
// 获取目标用户的信息
export function getUserProfiles(id) {
  return request({
    url: `/users/${id}/profiles`,
    method: 'get'
  })
}
